// removed by extract-text-webpack-plugin
module.exports = {"ModalPadding":"0.5rem","modalBody":"G3b3e38"};